import { Box, Button, ButtonGroup, Card, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loading from '../components/Loading';
import { Stack } from '@mui/system';
import { useGetDesignQuery, useUpdateDesignMutation } from '../features/model/designSlice';
import { svg_to_img } from '../helpers/images';
import DropArea from '../components/DropArea';
import { useListDesignCategoriesQuery } from '../features/model/designcategorySlice';
import DeleteIcon from '@mui/icons-material/Delete';

const DesignUpdateCard = ({onUpdateDesign = null}) => {
  return <Box sx={{margin: 2}}>
          <center><Typography variant="subtitle1">Upload a new SVG to<br />update the design</Typography></center>
          <Box sx={{marginLeft: 4, marginRight: 4, marginTop: 1, marginBottom: 1}}><DropArea fileHandler={onUpdateDesign}/></Box>
      </Box>;
}

const DesignView = () => {
    let params = useParams();

    const {data: design, error, isLoading } = useGetDesignQuery(params.designId)
    const categoriesQuery = useListDesignCategoriesQuery();

    const [uploadDesign, {isLoadingUpdate: isUpdating }] = useUpdateDesignMutation();
    const uploadImage = useCallback((files) => {
        let file = files[0];
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          const textStr = reader.result
          uploadDesign({design_id: params.designId, data: {contents: textStr}})
        }
        reader.readAsText(file)
    });

    if (isLoading || isUpdating || categoriesQuery.isLoading) {
      return <Loading />;
    }
    if (error || categoriesQuery.error) {
      return <div>Error: {error.error}</div>
    }

    var deactivation_category = null;
    categoriesQuery.data.objects.forEach(element => {
      if(element.name === "deactivated") {
        deactivation_category = element.id;
      }
    });

    console.log(design.category);

    return <Stack sx={{margin: 2}} spacing={2}>
        <ButtonGroup>
          <Button component={Link} to={`/designs/${design.category}`}>Back</Button>
        </ButtonGroup>
        <Paper>
            <Card>
                <Stack direction="row" sx={{margin: 2}} spacing={2}>
                  <img alt={design.name} style={{"width": 256, "height": "auto"}} src={svg_to_img(design.contents)} />
                  <Stack direction="column">

                    <TextField label="Name" defaultValue={design.name} sx={{width: 400}} onChange={(event) => {
                      uploadDesign({design_id: design.id, data: {name: event.target.value}});
                    }} />
                    {
                      (design.category && design.category === deactivation_category) ?
                        <Select label="Category" key="category" defaultValue={design.category} onChange={(event) => {
                          uploadDesign({design_id: design.id, data: {category: event.target.value}});
                        }}>
                          {
                            categoriesQuery.data.objects.map((dg) => 
                              <MenuItem key={dg.name} value={dg.id} selected={dg.id === design.category}>{dg.name}</MenuItem>
                            )
                          }
                        </Select>
                        :
                        (deactivation_category ?
                        <Button startIcon={<DeleteIcon />} onClick={() => {
                          uploadDesign({design_id: design.id, data: {category: deactivation_category}});
                        }}>Deactivate</Button> : <></>)
                    }
                    <DesignUpdateCard onUpdateDesign={uploadImage}/>
                  </Stack>
                </Stack>
            </Card>
        </Paper>
    </Stack>;
}

export default DesignView;
